import React from 'react'

class ExpertRating extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ratingMapping: [0, 0, 0, 0, 0]
    }
  }

  componentWillMount () {
    this.mapRatingToArray(this.props.rating)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.rating !== nextProps.rating) {
      this.mapRatingToArray(nextProps.rating)
    }
  }

  mapRatingToArray (rating) {
    const precision = rating - Math.floor(rating)
    let full = rating - precision
    let half = 0

    if (precision < 0.25) full = full
    else if (precision >= 0.25 && precision < 0.75) half = 0.5
    else if (precision >= 0.75) full += 1

    let ratingMapping = [0, 0, 0, 0, 0]

    for (let i = 0; i < full; i++) {
      ratingMapping[i] = 1
    }

    if (half === 0.5) ratingMapping[full] = 0.5

    this.setState({ratingMapping})
  }

  renderRatingStar (ratingMap, i) {
    if (ratingMap === 1) return <i key={i} className='rc-icon-star' />
    else if (ratingMap === 0.5) return <i key={i} className='rc-icon-star-half' />
    else return <i key={i} className='rc-icon-star-outline' />
  }

  renderRatingStars () {
    return this.state.ratingMapping.map(this.renderRatingStar)
  }

  render () {
    return (
      <div className='rating-stars' style={{display: this.props.display, fontSize: this.props.size, color: this.props.color, marginBottom: this.props.margin}}>
        {this.renderRatingStars()}
      </div>
    )
  }
}

export default ExpertRating



/** WEBPACK FOOTER **
 ** ./modules/shared/expert_rating.js
 **/